(function () {
  const Core = window.RB.Core;
  const { equip, buff, addPerVarPoint } = window.RB.CardLib;
  const { oneOnOne } = window.RB.CardLib.sfd;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Sea Monkey": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Sea Monkey",
          cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
          then: [{ op: "buff", to: "source" }],
          thenTargets: [],
        },
      ],
    },

    "Boneshiver": {
      abilities: [
        equip({ energy: 1, pips: 1, anyPower: 0, domains: ["body"] }),
      ],
      attachedTriggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, channel 1 rune exhausted",
          targets: [],
          program: [{ op: "channel", n: 1, exhausted: true }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Combat Chef": {},

    "Doran's Blade": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["body"] }),
      ],
    },

    "Hexdrinker": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["body"] }),
      ],
      attachedKw: [["deflect", null]],
    },

    "On the Hunt": { play: [{ op: "ready", spec: { type: "unit", friendly: true } }] },

    "Punch First": {
      play: [buff("$t1", 5)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +5 Might to..." }],
    },

    "Ruin Runner": { selfUntargetable: true },

    "Trinity Force": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["body"] }),
      ],
      attachedTriggers: [
        {
          on: "hold",
          optional: false,
          label: "When I hold, score 1 point",
          targets: [],
          program: [{ op: "points", n: 1 }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Veteran Poro": {},

    "Warmog's Armor": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["body"] }),
      ],
      attachedTriggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, buff me",
          targets: [],
          program: [{ op: "buff", to: "source" }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Buhru Captain": {
      play: [{
        op: "may", prompt: "Draw 1 or buff Buhru Captain?",
        then: [
          { op: "option", varKey: "mode", prompt: "Choose one", options: ["Draw 1", "Buff me"] },
          {
            op: "if", cond: { k: "varEq", key: "mode", value: 0 },
            then: [{ op: "draw", n: 1 }],
            else: [{ op: "buff", to: "source" }],
          },
        ],
      }],
    },

    "Dauntless Vanguard": { playToEnemyBf: true },

    Direwing: { entersReadyCond: { k: "controlsTagOther", tag: "Dragon" } },

    "Laurent Bladekeeper": { selfKwSpecs: [{ name: "ganking", value: null }] },

    "Yordle Explorer": {
      triggers: [{
        on: "finalizedCard", you: true,
        label: "a card with Power cost 2 or more: draw 1",
        cond: function (state, iid, ev) {
          const c = window.RB.Core.card(state, ev.iid);
          return !!c && (c.power || 0) >= 2;
        },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Fae Dragon": {
      targets: [{
        bind: "b", spec: { type: "unit", friendly: true }, min: 0, max: 4,
        prompt: "Buff up to four friendly units",
      }],
      play: [{ op: "buff", to: "$b" }],
      triggers: [{
        on: "buffSpent", you: true, label: "buff spent: play a Gold exhausted",
        program: [{ op: "token", name: "Gold", n: 1, exhausted: true }],
      }],
    },

    "Akshan, Mischievous": {
      addCosts: [{
        optional: true,
        cond: null,
        label: "Akshan, Mischievous",
        cost: { energy: 0, pips: 2, anyPower: 0, domains: ["body"] },
        thenTargets: [{
          bind: "ak", spec: { type: "gear", enemy: true }, min: 0,
          prompt: "Take which enemy gear?",
        }],
        then: [
          { op: "takeControl", to: "$ak", untilSourceLeaves: true },
          { op: "move", to: "$ak", dest: "base" },
          { op: "if", cond: { k: "targetTag", bind: "ak", tag: "Equipment" } },
          { op: "attach", to: "$ak", host: "source" },
        ],
      }],
    },

    "Jaull-Fish": {
      costMods: [{
        energyLess: {
          count: { type: "unit", friendly: true, minMight: 5, ignoreUntargetable: true },
          times: 2,
        },
      }],
    },

    "Petricite Monument": {
      auraKwSpecs: [{ name: "deflect", value: 1 }],
    },

    "Show of Strength": {
      play: [{
        op: "draw",
        n: { count: { type: "unit", friendly: true, minMight: 5, ignoreUntargetable: true } },
      }],
    },

    "Fiora, Peerless": {
      triggers: [
        {
          on: "attack", self: true, label: "attacking one on one: double my Might",
          condSpec: oneOnOne(),
          program: [{ op: "grant", to: "source", might: { mightOf: "source" }, dur: "combat" }],
        },
        {
          on: "defend", self: true, label: "defending one on one: double my Might",
          condSpec: oneOnOne(),
          program: [{ op: "grant", to: "source", might: { mightOf: "source" }, dur: "combat" }],
        },
      ],
    },

    "Lucian, Merciless": {
      triggers: [{
        on: "unitConquer", self: true, oncePerTurn: true,
        label: "first conquer each turn: ready me",
        program: [{ op: "ready", to: "source" }],
      }],
    },

    "Marching Orders": {
      targets: [
        { bind: "f", spec: { type: "unit", friendly: true }, prompt: "Choose a friendly unit anywhere" },
        { bind: "e", spec: { type: "unit", enemy: true, atBf: true }, prompt: "Choose an enemy unit at a battlefield" },
      ],
      play: [{ op: "fight", a: "$f", b: "$e" }],
      repeatCosts: [{ cost: { energy: 3, pips: 0, anyPower: 0, domains: null } }],
    },

    "Yone, Blademaster": {
      triggers: [{
        on: "unitConquer", self: true,
        label: "conquer an open battlefield: deal my Might to a unit in a base",
        condSpec: {
          k: "and",
          conds: [
            { k: "not", cond: { k: "showdownHere" } },
            {
              k: "not",
              cond: { k: "count", spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true } },
            },
          ],
        },
        program: [
          {
            op: "choose", bind: "t", spec: { type: "unit", enemy: true, inBase: true },
            prompt: "Deal Yone's Might to which enemy unit in a base?",
          },
          { op: "deal", to: "$t", n: "sourceMight" },
        ],
      }],
    },

    "Ancient Henge": {
      abilities: [{
        label: "Exhaust: pay any amount of Energy to Add that much rainbow",
        exhausts: true, reaction: true, isAdd: true,
        program: [{ op: "payAny", res: "energy", varKey: "henge", prompt: "Pay how much Energy?" }]
          .concat(addPerVarPoint("henge", 30, { anyPower: 1 })),
      }],
    },

    "Jax, Unrelenting": {
      triggers: [{
        on: "attached", optional: true,
        label: "an Equipment attached to me: pay 1 to draw 1",
        cond: function (state, iid, ev) {
          return ev.host === iid && window.RB.Core.hasTag(state, ev.iid, "Equipment");
        },
        program: [
          { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, skipOnFail: 1 },
          { op: "draw", n: 1 },
        ],
      }],
    },

    "Battle Mistress": {
      triggers: [
        {
          on: "recycleRune", you: true, optional: true, exhaustSelf: true,
          label: "exhaust me: play a Gold token exhausted",
          condSpec: { k: "selfReady" },
          program: [
            { op: "exhaust", to: "source" },
            { op: "token", name: "Gold", exhausted: true },
          ],
        },
        {
          on: "dies",
          label: "an enemy unit died: ready me",
          condSpec: { k: "and", conds: [{ k: "evSnapshotEnemy" }, { k: "evSnapshotUnit" }] },
          program: [{ op: "ready", to: "source" }],
        },
      ],
    },

    "Grand Duelist": {
      triggers: [{
        on: "becameMighty", you: true, optional: true, exhaustSelf: true,
        condSpec: { k: "selfReady" },
        label: "a unit you control became Mighty: exhaust me to channel 1 rune exhausted",
        program: [
          { op: "exhaust", to: "source" },
          { op: "channel", n: 1, exhausted: true },
        ],
      }],
    },

    "Kato the Arm": {
      triggers: [{
        on: "move", self: true, condSpec: { k: "evToBf" },
        label: "moved to a battlefield: pass my keywords and Might along",
        targets: [{
          bind: "kt", spec: { type: "unit", friendly: true },
          prompt: "Give my keywords and +Might equal to my Might to which friendly unit?",
        }],
        program: [{ op: "grant", to: "$kt", might: "sourceMight", keywordsOf: "source", dur: "turn" }],
      }],
    },

    "Strike Down": {
      targets: [
        {
          bind: "f", spec: { type: "unit", friendly: true, hasAttachment: true },
          prompt: "Which equipped friendly unit deals its Might?",
        },
        { bind: "e", spec: { type: "unit", enemy: true }, prompt: "Deal that damage to which enemy unit?" },
      ],
      play: [
        { op: "deal", to: "$e", n: { mightOf: "$f" } },
        {
          op: "choose", bind: "g",
          spec: { type: "gear", attached: true, attachedToBind: "f", equipment: true },
          prompt: "Detach which Equipment from it?",
        },
        { op: "detach", to: "$g" },
      ],
    },

    "Here to Help": {
      play: [{
        op: "may", prompt: "Play a unit from hand to a battlefield you control for 3 less?",
        then: [
          {
            op: "choose", bind: "u", spec: { zone: "hand", type: "unit", friendly: true },
            prompt: "Play which unit from your hand?",
          },
          { op: "chooseDest", varKey: "hh", myBfOnly: true, prompt: "Play it to which battlefield you control?" },
          { op: "playFrom", to: "$u", energyLess: 3, locVar: "hh" },
        ],
      }],
    },

    "Sivir, Ambitious": {
      triggers: [{
        on: "unitConquer", self: true, optional: true,
        label: "conquered with 5+ excess damage: deal that much to an enemy unit",
        condSpec: { k: "excessDamageAtLeast", n: 5 },
        targets: [{ bind: "t", spec: { type: "unit", enemy: true }, prompt: "Deal the excess damage to which enemy unit?" }],
        program: [{ op: "deal", to: "$t", n: { excessDamage: true } }],
      }],
    },

    "Riposte": {
      targets: [
        { bind: "f", spec: { type: "unit", friendly: true }, prompt: "Choose a friendly unit" },
        {
          bind: "t", spec: { zone: "chain", type: "spell", counterable: true },
          prompt: "Counter which spell?",
        },
      ],
      play: [
        { op: "grant", to: "$f", might: { chainEnergyOf: "$t" }, dur: "turn" },
        { op: "counter", to: "$t" },
      ],
    },
  });
})();
